import React from 'react';
import ReactHoverObserver from 'react-hover-observer';
import SVGChevron from '../../svg/Chevron';

class NavSubMenu extends React.Component {
  state = {
    isOpen: false
  };

  render() {
    const { label, Content } = this.props;
    return (
      <ReactHoverObserver
        onHoverChanged={this.handleHoverChanged}
        hoverOffDelayInMs={250}
      >
        <div
          className="a--blue nav-menu-list-item--fill"
          onClick={this.toggleOpen}
        >
          {label}
          <span className="chev">
            <SVGChevron
              className={
                this.state.isOpen ? 'svg--animate svg--flip-v' : 'svg--animate'
              }
            />
          </span>
        </div>
        <Content isOpen={this.state.isOpen} />
      </ReactHoverObserver>
    );
  }

  toggleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  handleHoverChanged = ({ isHovering }) => {
    if (this.state.isOpen && !isHovering) this.setState({ isOpen: false });
  };

  componentDidUpdate(prevProps, prevState) {
    // close om url change- this works because props won't change
    if (this.state.isOpen && prevState.isOpen) this.setState({ isOpen: false });
  }
}
export default NavSubMenu;



// WEBPACK FOOTER //
// ./src/components/nav/NavSubMenu.js